var _linearGradient, _linearGradient2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolFilter = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 800,
  height: 800,
  viewBox: "0 0 5.821 5.821",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#373737",
    stopOpacity: 0
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#373737",
    stopOpacity: 1
  }
})), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#d",
  id: "e",
  x1: 1.058,
  x2: 5.556,
  y1: 294.883,
  y2: 294.883,
  gradientTransform: "matrix(.94118 0 0 1 -6.552 1.587)",
  gradientUnits: "userSpaceOnUse"
})), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#d",
  id: "f",
  x1: 1.058,
  x2: 5.556,
  y1: 294.883,
  y2: 294.883,
  gradientTransform: "matrix(.94118 0 0 1 290.448 -294.354)",
  gradientUnits: "userSpaceOnUse"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -291.18)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.587 295.412h3.44v-3.44z",
  style: {
    fill: "#373737",
    fillOpacity: 0.37647059,
    stroke: "none",
    strokeWidth: ".26458332px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.587,
  cy: 295.412,
  r: 0.529,
  style: {
    opacity: 1,
    vectorEffect: "none",
    fill: "#373737",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.52916664,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 3.20000005,
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.027,
  cy: 291.973,
  r: 0.529,
  style: {
    opacity: 1,
    vectorEffect: "none",
    fill: "#373737",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.52916664,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 3.20000005,
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.933 291.88-3.439 3.438.188.188 3.438-3.439z",
  style: {
    color: "#000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    lineHeight: "normal",
    fontFamily: "sans-serif",
    fontVariantLigatures: "normal",
    fontVariantPosition: "normal",
    fontVariantCaps: "normal",
    fontVariantNumeric: "normal",
    fontVariantAlternates: "normal",
    fontFeatureSettings: "normal",
    textIndent: 0,
    textAlign: "start",
    textDecoration: "none",
    textDecorationLine: "none",
    textDecorationStyle: "solid",
    textDecorationColor: "#000",
    letterSpacing: "normal",
    wordSpacing: "normal",
    textTransform: "none",
    writingMode: "lr-tb",
    direction: "ltr",
    textOrientation: "mixed",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    whiteSpace: "normal",
    shapePadding: 0,
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    isolation: "auto",
    mixBlendMode: "normal",
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    solidColor: "#000",
    solidOpacity: 1,
    vectorEffect: "none",
    fill: "#373737",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 0.26458332,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M-5.556 296.206h4.233v.529h-4.233z",
  style: {
    opacity: 1,
    vectorEffect: "none",
    fill: "url(#e)",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.5133689,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 3.20000005,
    strokeOpacity: 1
  },
  transform: "scale(-1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.444.265h4.233v.529h-4.233z",
  style: {
    opacity: 1,
    vectorEffect: "none",
    fill: "url(#f)",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 0.5133689,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 3.20000005,
    strokeOpacity: 1
  },
  transform: "matrix(0 1 1 0 0 0)"
})));
export { SvgToolFilter as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-filter.svg";